exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1QDTZfBsizkS8O4Jej5a3A{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}", ""]);

// exports
exports.locals = {
	"showTabBar": "_1QDTZfBsizkS8O4Jej5a3A"
};